import { Stack, Skeleton } from '@mui/material';

type Props = {
  rows?: number;
  loading: boolean;
  children?: React.ReactNode;
};

export default function TradeTxSkeleton({ rows = 1, loading, children }: Props) {
  if (loading) {
    const array = Array.from({ length: rows }, (_, index) => index);

    return array.map((index) => (
      <Stack
        spacing={2}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        key={index}
        sx={{
          p: 2.5,
          border: (theme) => `solid 1px ${theme.palette.divider}`,
          borderRadius: 2,
        }}
      >
        <Stack spacing={1} justifyItems="center" width="33.33%">
          <Skeleton sx={{ width: 180, height: 12 }} />
          <Skeleton sx={{ width: 120, height: 10 }} />
          <Skeleton sx={{ width: 120, height: 10 }} />
          <Skeleton sx={{ width: 140, height: 10 }} />
        </Stack>
        <Stack width="33.33%" alignItems="center">
          <Skeleton sx={{ borderRadius: 1, width: 60, height: 30, flexShrink: 0 }} />
        </Stack>
        <Stack width="33.33%" alignItems="flex-end">
          <Skeleton sx={{ borderRadius: 1, width: 100, height: 30, flexShrink: 0 }} />
        </Stack>
      </Stack>
    ));
  }

  return children;
}
